import { useState } from "react";
import type { Faq } from "@/mocks/faqs";

export default function FaqAccordion({ items, defaultOpen = true }: { items: Faq[]; defaultOpen?: boolean }) {
  const [openId, setOpenId] = useState<string | null>(defaultOpen ? items[0]?.id ?? null : null);

  return (
    <div className="divide-y divide-background-200 rounded-xl border border-background-200/70 bg-background-50">
      {items.map((item) => {
        const open = openId === item.id;
        return (
          <div key={item.id}>
            <button
              type="button"
              onClick={() => setOpenId(open ? null : item.id)}
              aria-expanded={open}
              className="flex w-full items-center justify-between gap-4 px-5 py-4 text-left md:px-6"
            >
              <span className="flex items-center gap-3">
                <span className="font-ink text-lg text-primary-500">问</span>
                <span className="font-heading text-sm font-semibold text-foreground-950 md:text-base">{item.q}</span>
              </span>
              <span className={`flex h-8 w-8 shrink-0 items-center justify-center rounded-full bg-background-100 text-foreground-600 transition-transform ${open ? "rotate-180" : ""}`}>
                <i className="ri-arrow-down-s-line text-xl"></i>
              </span>
            </button>
            {open && (
              <div className="px-5 pb-5 md:px-6">
                <p className="ml-11 text-sm leading-relaxed text-foreground-600">{item.a}</p>
              </div>
            )}
          </div>
        );
      })}
    </div>
  );
}